import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "MultipleTopVisibilityBannersWrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Banner = _resolveComponent("Banner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bannerIds, (id) => {
      return (_openBlock(), _createBlock(_component_Banner, {
        containerId: id,
        type: _ctx.type,
        cssClass: _ctx.cssClass
      }, null, 8 /* PROPS */, ["containerId", "type", "cssClass"]))
    }), 256 /* UNKEYED_FRAGMENT */))
  ]))
}